import React from 'react';
import './Processing.css';

export default function Processing(props) {
    return props.show ? (<div id="processing" title="Processing">&nbsp;</div>) : null;
}
